import _defineProperty from "@babel/runtime-corejs3/helpers/esm/defineProperty";
var render = function render(_c, _vm) {
  return _vm.$options.m.shouldShowStatus(_vm.props) ? _c('span', {
    staticClass: "kiwi-awaystatusindicator",
    class: _defineProperty({
      'kiwi-awaystatusindicator--offline': !_vm.props.user || _vm.props.user.isOffline(),
      'kiwi-awaystatusindicator--away': _vm.props.user && _vm.props.user.isAway(),
      'kiwi-awaystatusindicator--self': _vm.$options.m.isUserSelf(_vm.props)
    }, _vm.data.staticClass, !!_vm.data.staticClass),
    on: {
      "click": function click($event) {
        return _vm.$options.m.toggleSelfAway(_vm.props);
      }
    }
  }) : _vm._e();
};
var staticRenderFns = [];
export { render, staticRenderFns };